import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

import { BsTwitterX } from 'react-icons/bs';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const LandingFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-black px-5 py-20">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-12">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-center">
          <img src="/iopsspace_white.png" className="w-[210px]" alt="" />
          <div className="flex gap-2">
            <Link className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2c2c2c]" to="https://x.com/IOPS_SPACE" target="_blank">
              <BsTwitterX className="text-white" size={20} />
            </Link>
            <Link className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2c2c2c]" to="https://www.facebook.com/profile.php?id=61562774219979&locale=ko_KR" target="_blank">
              <FaFacebookF className="text-white" size={20} />
            </Link>
            <Link className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2c2c2c]" to="https://www.instagram.com/iops_space?fbclid=IwY2xjawGjuzRleHRuA2FlbQIxMAABHaYrd3dnqc6GnZqC2llFqyAfqUlVdqih0XtHDGHZEcxFzFSQKON6U7aAGQ_aem_sBYO7BKqM2ue9iYLO2NPJQ" target="_blank">
              <FaInstagram className="text-white" size={20} />
            </Link>
            <Link className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2c2c2c]" to="https://www.linkedin.com/company/i-ops/" target="_blank">
              <FaLinkedinIn className="text-white" size={20} />
            </Link>
          </div>
        </div>
        {/* <div className=''>
          <div className='flex gap-3'>
            <p className="text-[#646464]">상호명</p>
            <p className='text-white'>주식회사 아이옵스</p>
            <p className="text-[#646464]">대표자</p>
            <p className='text-white'>김영욱</p>
            <p className="text-[#646464]">주소</p>
            <p className='text-white'>대전광역시 서구 월평중로30, 301호(월평동, 트리플타워)</p>
            <p className="text-[#646464]">통신판매업신고번호</p>
            <p className='text-white'>2024-대전서구-2384</p>
            <p className="text-[#646464]">사업자번호</p>
            <p className='text-white'>514-88-00036</p>
          </div>
          <div className='flex gap-3 mt-2'>
            <p className="text-[#646464]">Email</p>
            <p className='text-white'>contact@i-ops.co.kr</p>
            <p className="text-[#646464]">전화번호</p>
            <p className='text-white'>042-322-7600</p>
          </div>
        </div> */}
        <div className="flex flex-col flex-wrap justify-between gap-5 md:flex-row">
          <div className="max-w-[264px] text-sm text-white">
            <p className="text-[#646464]">{t('landingFooter.location')}</p>
            <p>{t('landingFooter.address')}</p>
          </div>
          <div className="max-w-[264px] text-sm text-white">
            <p className="text-[#646464]">{t('landingFooter.email')}</p>
            <p>contact@i-ops.co.kr</p>
          </div>
          <div className="max-w-[264px] text-sm text-white">
            <p className="text-[#646464]">{t('landingFooter.phone')}</p>
            <p>+82-42-322-7600</p>
            <p>{t('landingFooter.businessHours')}</p>
            <p>{t('landingFooter.lunch')}</p>
            <p>{t('landingFooter.closed')}</p>
          </div>
          <div className="max-w-[264px] text-sm text-white">
            <p className="text-[#646464]">{t('landingFooter.bank')}</p>
            <p>{t('landingFooter.bankName')}</p>
            <p>(주)아이옵스</p>
            <p>748301-01-604539</p>
          </div>
          <div className="max-w-[264px] text-sm text-white">
            <p className="text-[#646464]">{t('landingFooter.legal')}</p>
            <p>
              <Link to="/privacy-policy">{t('landingFooter.privacyPolicy')}</Link>{' '}
              <Link to="/terms-of-service">{t('landingFooter.termsOfService')}</Link>
            </p>
          </div>
        </div>
        <p className="text-sm text-white">&copy; 2024 Copyright IOPS. All rights reserved</p>
      </div>
    </div>
  );
};

export default LandingFooter;
